export const TOGGLE_SAVE_PAYMENT = 'toggle-save-payment';
const toggleSavePayment = () => ({ type: TOGGLE_SAVE_PAYMENT });
export default toggleSavePayment;
